import { useMutation } from 'react-query';
import { deleteRegisterResultAppendix } from 'apis/registerResult';

const useMutationDeleteRegisterResultAppendix = () => {
  const { mutateAsync, ...rest } = useMutation(deleteRegisterResultAppendix);

  return {
    mutateAsync,
    ...rest,
  };
};

export default useMutationDeleteRegisterResultAppendix;
